import initializeBlock from './initialize-block';
import setBlockHTML from './set-block-html';
import setBlocks from './set-blocks';
import setCategories from './set-categories';

export default {
  initializeBlock,
  setBlockHTML,
  setBlocks,
  setCategories,
};
